import { API_STORE_MGMT } from 'utils/constants'
import Api from './axiosInstance'
import { StoreFormData } from 'components/storeManagement/utils'
import { UpdateStoreFormData } from 'pages/storeManagement/updateStore'

type FetchStoresParams = {
  limit: number
  page: number
  isActive?: boolean
  search?: string
}

const fetchStores = ({ limit, page, search, isActive }: FetchStoresParams) => {
  const options: any = {}

  if (search) {
    options.search = search
  }

  if (isActive !== undefined) {
    options.isActive = isActive
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_STORE_MGMT.STORE}?${params}`,
  })
}

const createStore = (data: StoreFormData) => {
  return Api.post({ url: API_STORE_MGMT.STORE, data: data })
}

const fetchStore = (storeId: string) => {
  return Api.get({ url: `${API_STORE_MGMT.STORE}/${storeId}` })
}

const updateStore = (id: string, data: UpdateStoreFormData) => {
  return Api.patch({ url: `${API_STORE_MGMT.STORE}/${id}`, data })
}

const deleteStore = (id: string) => {
  return Api.delete({ url: `${API_STORE_MGMT.STORE}/${id}` })
}

export { fetchStore, fetchStores, createStore, updateStore, deleteStore }
